var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 122,
    viewBox: "0 0 107 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9686 56.2673H88.315V45.936H41.8242L49.9686 56.2673Z",
    fill: "url(#paint0_linear_5056_5788)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8242 64.0161V73.056H60.6315L70.2352 64.0161H41.8242Z",
    fill: "url(#paint1_linear_5056_5788)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5332 85.3239V46.2588L50.2188 58.2043V85.3239H40.5332Z",
    fill: "url(#paint2_linear_5056_5788)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.998 0V26.9812L82.1591 43.8409L105.494 30.3474L52.998 0Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0014 0L0.5 30.3474L23.8403 43.8409L53.0014 26.9812V0Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 30.3472V91.0592L23.8403 77.5658V43.8407L0.5 30.3472Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8403 77.5547L53.0014 94.4144V121.401L0.5 91.0482L23.8403 77.5547Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1591 77.5547L105.494 91.0482L52.998 121.401V94.4144L82.1591 77.5547Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.998 0V26.9812L82.1591 43.8409L105.494 30.3474L52.998 0Z",
    fill: "url(#paint3_linear_5056_5788)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8403 77.5547L0.5 91.0482L53.0014 121.401V94.4144L23.8403 77.5547Z",
    fill: "url(#paint4_linear_5056_5788)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M106.514 29.5303L57.9199 55.9884H106.514V29.5303Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5056_5788",
    x1: 46.9144,
    y1: 51.3263,
    x2: 83.0814,
    y2: 43.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5056_5788",
    x1: 70.2352,
    y1: 68.536,
    x2: 41.4296,
    y2: 68.5483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.725,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5056_5788",
    x1: 51.833,
    y1: 45.7515,
    x2: 43.7681,
    y2: 86.3055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5056_5788",
    x1: 65.7312,
    y1: 9.08581,
    x2: 95.6447,
    y2: 52.2944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5056_5788",
    x1: 0.5,
    y1: 99.478,
    x2: 53.0014,
    y2: 99.478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopOpacity: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLogin);
export default __webpack_public_path__ + "static/media/LogoLogin.3230c21790bde5293b969eff833c1ac1.svg";
export { ForwardRef as ReactComponent };